import sightingApi from "@/services/api/sightings";
import utils from "@/helpers/utils";
import enums from "@/helpers/enums";

function formatSightingForApi(sighting) {
  // sighting.sightingTime = utils.toIsoDateString(sighting.sightingTime);
  sighting.sightingDate = utils.toIsoDateString(sighting.sightingDate);
  return sighting;
}

const state = {
  sighting: {},
  isSaving: false,
  isSavingEmail: false,
  isSaved: false,
  isDialogOpen: false,
  isListed: false,
  emailPreview: {},
  specOtherValue: "",
  incOtherValue: "",
  locOtherValue: "",
  whales: [],
  pendingEdit: null,
};

const getters = {
  saving: (state) => state.isSaving,
  emailSaving: (state) => state.isSavingEmail,
  saved: (state) => state.isSaved,
  sighting: (state) => state.sighting,
  dialog: (state) => state.isDialogOpen,
  button: (state) => (state.sighting && state.sighting.id ? "Save" : "Create"),
  title: (state) =>
    state.sighting && state.sighting.id
      ? `Edit Sighting ${state.sighting.sightingNumber}`
      : "Create New Sighting",
  emailPreview: (state) => state.emailPreview,
  specOtherValue: (state) => state.specOtherValue,
  incOtherValue: (state) => state.incOtherValue,
  locOtherValue: (state) => state.locOtherValue,
  whales: (state) => state.whales,
};

const actions = {
  async open({ commit }, { sighting }) {
    commit("open", { sighting });
    commit("handleOptionalTextboxes", { sighting });
    if (sighting && sighting.id) {
      sightingApi.group(sighting.sightingNumber).then(result => {
        const rows = result?.data ?? [];
        const primaryRow = rows.find(r => r.isPrimaryOfGroup) ?? rows[0];
        const primaryTime = primaryRow?.sightingTime ?? '';
        const whaleMap = {};
        for (const row of rows) {
          const key = row.whaleId;
          if (!whaleMap[key]) {
            const bhvArray = row.bhv ? row.bhv.split(',') : [];
            const hasJoin = bhvArray.includes('J') || bhvArray.includes('JOIN');
            const joinTime = hasJoin && row.sightingTime !== primaryTime ? row.sightingTime : '';
            whaleMap[key] = {
              whaleId: row.whaleId,
              whaleName: row.whaleName,
              whaleType: row.whaleType,
              is_escort: row.isEscort,
              bhv: row.bhv ? row.bhv.split(',') : [],
              groupNumber: row.groupNumber,
              groupMemberId: row.groupMemberId,
              groupSize: row.groupSize,
              totalBnf: row.totalBnf,
              scarSequence: row.scarSequence,
              joinTime,
              isiSpecies: row.isiSpecies || '',
              features: [],
            };
          }
          if (row.featureName || row.photoNumber) {
            whaleMap[key].features.push({ featureName: row.featureName || '', photoNumber: row.photoNumber || '' });
          }
        }
        const whales = Object.values(whaleMap).map(w => {
          if (w.features.length === 0) w.features = [{ featureName: '', photoNumber: '' }];
          return w;
        });
        commit("updateWhaleList", whales);
      });
    } else {
      commit("updateWhaleList", []);
    }
  },
  async openByNumber({ dispatch }, sightingNumber) {
    const result = await sightingApi.group(sightingNumber);
    const rows = result?.data ?? [];
    const primary = rows.find((r) => r.isPrimaryOfGroup) ?? rows[0];
    if (primary) {
      dispatch("open", { sighting: primary });
    }
  },
  close({ commit }) {
    commit("close");
  },
  async update({ commit, dispatch }, { sightings }) {
    commit("saving", { isSaving: true });

    const processed_sightings = sightings.map((sighting) => formatSightingForApi(sighting));

    const sightingResult = await sightingApi.update(processed_sightings);

    if (sightingResult) {
      dispatch("sightings/reload", {}, { root: true });
      commit("saveComplete", { isSaveComplete: true });
    } else {
      commit("saveComplete", { isSaveComplete: false });
    }
  },
  async create({ commit, dispatch }, { sightings }) {
    commit("saving", { isSaving: true });
    const processed_sightings = [];
    for (const i in sightings) {
      console.log(i)
      console.log(typeof i)
      const sighting = sightings[i]
      // sighting.sightingDate = sighting.sightingYear + "-" + sighting.sightingMonth + "-" + sighting.sightingDay + "T" + sighting.sightingTime
      // formatSightingForApi(sighting)
      sighting.sightingNumber = "1"; //temporarily set for api call, will be overwritten in the backend with the correct value
      sighting.lat = sighting.lat.toString();
      sighting.lon = sighting.lon.toString();
      sighting.sightingYear = +sighting.sightingYear;
      sighting.sightingMonth = +sighting.sightingMonth;
      sighting.sightingDay = +sighting.sightingDay;
      sighting.isPrimaryOfGroup = i === "0";

      processed_sightings.push(sighting)
    }

    const sightingResult = await sightingApi.create(processed_sightings);

    if (sightingResult) {
      dispatch("sightings/reload", {}, { root: true });
      commit("saveComplete", { isSaveComplete: true });
    } else {
      commit("saveComplete", { isSaveComplete: false });
    }
  },
  resetSaving({ commit }) {
    commit("saving", { isSaving: false })
  },
  async publicCreate({ commit, dispatch }, { sighting }) {
    commit("saving", { isSaving: true });
    sighting.sightingNumber = "1"; //temporarily set for api call, will be overwritten in the backend with the correct value
    const sightingResult = await sightingApi.publicCreate(formatSightingForApi(sighting));

    if (sightingResult) {
      dispatch("sightings/reload", {}, { root: true });
      commit("saveComplete", { isSaveComplete: true });
    } else {
      commit("saveComplete", { isSaveComplete: false });
    }
  },
  async sendEmail({ commit }, { sightingId, emailRequest }) {
    commit("emailSaving", { isSaving: true })
    await sightingApi.sendEmail(sightingId, emailRequest);
    commit("emailSaving", { isSaving: false });
  },
  async previewEmail({ commit }, { sightingId, emailRequest }) {
    commit("emailSaving", { isSaving: true })
    const previewBody = await sightingApi.previewEmail(sightingId, emailRequest);
    commit("emailPreview", { emailPreview: previewBody.data.previewBody })
    commit("emailSaving", { isSaving: false });
  },
  async addToSightingWhales({ commit, state }, whale) {
    const cloned = JSON.parse(JSON.stringify(whale));
    const existing = state.whales.findIndex(w => w.whaleId === cloned.whaleId);
    if (existing >= 0) {
      const newList = [...state.whales];
      newList[existing] = cloned;
      commit("updateWhaleList", newList);
    } else {
      commit("addToSightingWhales", cloned);
    }
  },
  async removeFromSightingWhales({ commit, state }, whaleId) {
    const newList = state?.whales?.filter(whale => whale.whaleId !== whaleId) ?? []
    commit("updateWhaleList", newList);
  },
  requestEdit({ commit }, sighting) {
    commit("setPendingEdit", sighting);
  },
  consumePendingEdit({ state, commit, dispatch }) {
    if (state.pendingEdit) {
      const sighting = state.pendingEdit;
      commit("setPendingEdit", null);
      dispatch("open", { sighting });
    }
  }
};

const mutations = {
  open(state, { sighting }) {
    state.sighting = { ...sighting };
    state.isSaving = false;
    state.isDialogOpen = true;
  },
  close(state) {
    state.isDialogOpen = false;
    state.isSaving = false;
    state.sighting = {};
    state.whales = [];
    state.specOtherValue = "";
    state.incOtherValue = "";
    state.locOtherValue = "";
  },
  saving(state, { isSaving }) {
    state.isSaving = isSaving;
  },
  emailSaving(state, { isSaving }) {
    state.isSavingEmail = isSaving;
  },
  emailPreview(state, { emailPreview }) {
    state.emailPreview = emailPreview;
  },
  saveComplete(state, { isSaveComplete }) {
    if (isSaveComplete) {
      state.isSaved = true;
      state.isDialogOpen = false;
      state.sighting = {};
    }
    state.isSaving = false;
  },
  handleOptionalTextboxes(state, { sighting }) {
    Object.values(enums.species).forEach((value) => {
      if (sighting?.species === value.toString()) {
        state.isListed = true;
      }
    });
    if (!state.isListed) {
      state.specOtherValue = sighting?.species;
      state.sighting.species = "Other";
    }
    state.isListed = false;

    Object.values(enums.incidentType).forEach((value) => {
      if (sighting?.incidentNature === value.toString()) {
        state.isListed = true;
      }
    });
    if (!state.isListed) {
      state.incOtherValue = sighting?.incidentNature;
      state.sighting.incidentNature = "Other";
    }
    state.isListed = false;

    Object.values(enums.injuryLocation).forEach((value) => {
      if (sighting?.injuryLocation === value.toString()) {
        state.isListed = true;
      }
    });
    if (!state.isListed) {
      state.locOtherValue = sighting?.injuryLocation;
      state.sighting.injuryLocation = "Other";
    }
    state.isListed = false;
  },
  updateWhaleList(state, whales) {
    state.whales = whales;
  },
  addToSightingWhales(state, whale) {
    state.whales.push(whale);
  },
  setPendingEdit(state, sighting) {
    state.pendingEdit = sighting;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
